import React, { useEffect } from 'react';
import { Box, Container } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import FadeIn from 'react-fade-in';
import { useTranslation } from 'react-i18next';
import Page from 'src/components/Page';
import { useDispatch } from 'react-redux';
import {
  CLEAR_BUSINESS_METRICS,
  loadBusinessMetricsResume
} from 'src/store/actions/businessActions';
import { QuotesMetricsBalanceOptions } from 'src/utils/constants/business';
import Toolbar from './Toolbar';
import MetricsTabsList from './ResumeTabsList';

const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const ResumeView = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      loadBusinessMetricsResume({
        balance: QuotesMetricsBalanceOptions.AMOUNT
      })
    );
    return () => dispatch({ type: CLEAR_BUSINESS_METRICS });
  }, []);

  return (
    <Page className={classes.root} title={t('NAVIGATION.METRICS')}>
      <FadeIn transitionDuration={200}>
        <Container maxWidth={false}>
          <Toolbar />
          <Box mt={3}>
            <MetricsTabsList />
          </Box>
        </Container>
      </FadeIn>
    </Page>
  );
};

export default ResumeView;
